import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import axios from "../../api/axios";
import Select from "../select/Select";
import { useDispatch } from "react-redux";
import { setSchool } from "../../redux/formDataSlice";


const School = ({ control, errors, setValue }) => {
  const [data, setData] = useState([]);
  const [otro, setOtro] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const getData = async () => {
      let response = await axios.get("schools");

      let result = response.data.map(e => {
        return {
          ...e,
          label: e.nombre,
          value: e.nombre
        }
      })

      setData(result);
    };

    getData();

    return () => {

    };
  }, []);

  useEffect(() => {
    setValue("otro_school", otro);
  }, [setValue, otro]);

  const handleChange = (e) => {
    if (e?.value === "otro") {
      setOtro(true);
    }
    else {
      setOtro(false);
      dispatch(setSchool(e));
    }
  };

  const handleInput = (e) => {
    setValue("name_school", e.target.value);
  };

  const handleBlur = (e) => {
    dispatch(setSchool({ nombre: e.target.value }));
  };


  return (
    <div className="step-form">
      <div className="text-center">
        <h6>
          Datos de la escuela
        </h6>
      </div>
      <div className="forms">
        <Form.Group>
          <Row className="mb-3">
            <Col>
              <Form.Label>Nombre</Form.Label>
              <Select
                name="name_school"
                control={control}
                options={data?.length ? [...data, { label: "Otro", value: "otro" }] : [{ label: "Otro", value: "otro" }]}
                className={`${errors.name_school ? "is-invalid" : ""}`}
                handleChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name_school?.message}
              </Form.Control.Feedback>
            </Col>
          </Row>

          {otro ? (
            <Row>
              <Col>
                <Form.Control
                  placeholder="Ingrese el nombre de la escuela."
                  onChange={handleInput}
                  onBlur={handleBlur}
                />
              </Col>
            </Row>
          ) : ""}

        </Form.Group>
      </div>
    </div>
  )
};


export default School;